var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('counsel-card-row', {
    attrs: {
      "label": "첨부파일"
    }
  }, [_vm.files.length ? [_c('v-chip-group', _vm._l(_vm.files, function (file, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "value": file._id,
        "href": file.url,
        "download": ""
      }
    }, [_vm._v(" " + _vm._s(file.fileName) + " ")]);
  }), 1)] : [_vm._v("첨부파일이 없습니다.")]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }